import { render, staticRenderFns } from "./MgrupoenvasadoGrid.vue?vue&type=template&id=e7463456"
import script from "./MgrupoenvasadoGrid.vue?vue&type=script&lang=js"
export * from "./MgrupoenvasadoGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports